import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CashAdvanceComponent } from './cash-advance/cash-advance.component';
import { LiquidationComponent } from './liquidation/liquidation.component';
import { ReimbursementComponent } from './reimbursement/reimbursement.component';
import { DisbursementNavigatorComponent } from './disbursement-navigator/disbursement-navigator.component';
import { DisbursementComponent } from './disbursement.component';
import { ViewCashAdvanceComponent } from './cash-advance/view-cash-advance/view-cash-advance.component';
import { ViewReimbursementComponent } from './reimbursement/view-reimbursement/view-reimbursement.component';
import { ViewLiquidationComponent } from './liquidation/view-liquidation/view-liquidation.component';
import { ViewDisbursementVoucherComponent } from './disbursement-voucher/view-disbursement-voucher/view-disbursement-voucher.component';

const routes: Routes = [
  { path: '', component: DisbursementNavigatorComponent },
  { path: 'list', component: DisbursementComponent },
  { path: 'disbursement-voucher', component: ViewDisbursementVoucherComponent },

  { path: 'cash-advance', component: CashAdvanceComponent },
  { path: 'cash-advance/:id', component: ViewCashAdvanceComponent },

  { path: 'reimbursement', component: ReimbursementComponent },
  { path: 'reimbursement/:id', component: ViewReimbursementComponent },

  { path: 'liquidation', component: LiquidationComponent },
  { path: 'liquidation/:id', component: ViewLiquidationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DisbursementRoutingModule { }
